'use client';

/**
 * Forwards Web Vitals (LCP, CLS, INP, TTFB, FCP) to the telemetry reporter
 * as breadcrumbs. Renders nothing; mounted once in the root layout.
 */

import { useReportWebVitals } from 'next/web-vitals';
import { reportWebVital } from '@/lib/telemetry';

export default function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    reportWebVital(metric);
  });
  return null;
}
